import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import AuthHeader from "../../../pages/AuthHeader/AuthHeader";
import Footer from "../../molecules/Footer/Footer";
import { GetInOnGooglePlaySection } from "../../organisms/GetInOnGooglePlayBtn/GetInOnGooglePlayBtn";
import ServiceSelectionList from "../../organisms/ServiceSelectionList/ServiceSelectionList";
import styles from "./SearchPageTemplate.module.css";
export default function SearchPageTemplate(_ref) {
  var searchElement = _ref.searchElement,
      searchResult = _ref.searchResult,
      exclude = _ref.exclude;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(AuthHeader, {}), /*#__PURE__*/_jsx("div", {
      className: styles.search,
      children: searchElement
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      id: "search_result",
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.our_services,
        children: [/*#__PURE__*/_jsx("h3", {
          className: styles.center,
          children: "Also Search for"
        }), /*#__PURE__*/_jsx(ServiceSelectionList, {
          onCategoryClick: undefined,
          exclude: exclude
        })]
      }), /*#__PURE__*/_jsx(GetInOnGooglePlaySection, {}), /*#__PURE__*/_jsx("div", {
        className: styles.search_result_container,
        children: /*#__PURE__*/_jsxs("div", {
          className: styles.search_result,
          children: [/*#__PURE__*/_jsx("div", {
            className: styles.search_result_head,
            children: "Search Results"
          }), searchResult]
        })
      })]
    }), /*#__PURE__*/_jsx(Footer, {})]
  });
}